const { DELAY_THROTTLE } = require('./consts');
const asyncImport = require('util/asyncImport').default;
const { stuttering, default: onWidthResize } = require('./onWidthResize');

const POS_FIX_TOP = 'pos_fix_top';
const POS_UNFIX_BOTTOM = 'pos_unfix_bottom';
const POS_UNFIX = 'pos_unfix';

module.exports = {
	async init(fixedElement, containerElement, marginTop, marginBottom) {
		this.fixedElement = fixedElement;
		this.containerElement = containerElement;
		this.marginTop = marginTop;
		this.marginBottom = marginBottom;
		this.activated = false;

		await asyncImport(this, 'throttle');

		this.declareEvents();
		this.activate();
	},
	declareEvents() {
		this.scrollEvent = this.throttle(
			this.checkPositions.bind(this),
			DELAY_THROTTLE,
		);
		this.resizeEvent = onWidthResize(
			() => {
				this.lastPos = null;
				this.checkPositions();
			},
			stuttering.THROTTLE,
			50,
			true,
		);
	},
	activate() {
		if (!this.activated) {
			this.activated = true;
			this.activateEvents(true);
			this.checkPositions();
		}
	},
	deactivate() {
		if (this.activated) {
			this.activated = false;
			this.activateEvents(false);
			this.unfixElement();
		}
	},
	activateEvents(activate) {
		const method = activate ? 'addEventListener' : 'removeEventListener';
		window[method]('scroll', this.scrollEvent);
		window[method]('resize', this.resizeEvent);
		this.lastPos = null;
	},
	checkPositions() {
		const containerBox = this.containerElement.getBoundingClientRect();
		const fixedBottom = this.fixedElement.offsetHeight + this.marginTop;
		const isPastTop = containerBox.top <= this.marginTop;
		const isPastBottom = containerBox.bottom - this.marginBottom <= fixedBottom;
		let position = null;

		if (isPastTop && !isPastBottom) position = POS_FIX_TOP;
		else if (isPastBottom) position = POS_UNFIX_BOTTOM;
		else position = POS_UNFIX;

		this.setPosition(position, containerBox);
	},
	setPosition(position, containerBox) {
		if (position !== this.lastPos) {
			switch (position) {
				case POS_FIX_TOP:
					this.fixElement(containerBox);
					break;
				case POS_UNFIX_BOTTOM:
					this.fixElement(containerBox, true);
					break;
				default:
					// POS_UNFIX
					this.unfixElement();
					break;
			}
		}
	},
	fixElement(box, bottom) {
		const { left } = box;
		const style = this.fixedElement.style;

		style.position = bottom ? 'absolute' : 'fixed';
		style.top = bottom ? null : this.marginTop + 'px';
		style.bottom = bottom ? this.marginBottom + 'px' : null;
		style.left = bottom ? 0 : left + 'px';

		this.lastPos = bottom ? POS_UNFIX_BOTTOM : POS_FIX_TOP;
	},
	unfixElement() {
		const style = this.fixedElement.style;
		style.position = null;
		style.top = null;
		style.left = null;
		this.lastPos = POS_UNFIX;
	},
};
